module.exports = __webpack_public_path__ + "top-bg.jpg?f66519841d6ee14ef8c5d410a6d93598";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-bg.jpg
// module id = 19
// module chunks = 0